<section class="header">
  <div class="title">
    <h2 class="shadowtxt letterspacing1">{{sectionTitle}}</h2>
  </div>
  <div class="clip"></div>
</section>
